import { createStore } from "vuex";

export default createStore({
  state: {
    base_url: (() => {
      // 使用立即执行函数初始化 base_url
      if (process.env.NODE_ENV === "development") {
        return process.env.VUE_APP_BASE_API + "/api";
      }
      if (window.location.hostname.includes("192.168.0.6")) {
        return process.env.VUE_APP_BASE_API;
      } else if (window.location.hostname.includes("192.168.6.6")) {
        return process.env.VUE_APP_Other_API;
      }
      return process.env.VUE_APP_External_API;
    })(),
  },
  getters: {
    getBaseURLInfo(state) {
      return state.base_url;
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
